import businessAddressesService from "@/services/businessAddresses";
import companyService from "@/services/company";
import Vue from "vue";
import { i18n } from "@/main";
import { store } from "@/store/store";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";

export const checkCompanyId = {
  async beforeRouteEnter(to, from, next) {
    const { data } = await companyService.getCompany();
    const companyId = data.length > 0 ? data[0].id : null;

    if (companyId) {
      await store.dispatch("company/setCompanyId", companyId);
      next();
      return;
    }

    next({
      name: "wizard-step-1"
    });
  }
};

export const checkBusinessAddressesAndWebsitesData = {
  async beforeRouteEnter(to, from, next) {
    const user = await JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEYS.USER)
    );

    if (!user) next({ name: "session-login" });

    const businessAddresses = await businessAddressesService.getBusinessAddressesData();
    if (businessAddresses.data.length > 0) {
      next(async vm => {
        await store.dispatch("company/fetchCompanyStatus");
        await store.commit("company/SET_LOADING", false);
        if (store.state.company.company.id) {
          return true;
        } else {
          vm.$router.push({
            name: "wizard-step-1"
          });
        }
      });

      return true;
    }

    Vue.notify({
      group: "default",
      type: "error",
      text: i18n.t("message.wizard.companyInWeb.noAddressesSelected")
    });

    next(false);
  }
};
